import createSagaMiddleware from 'redux-saga';
import { applyMiddleware, createStore, compose } from 'redux';
import { rootSaga } from 'common/sagas/index';
import { rootReducer } from 'common/reducers/index';

const sagaMiddleware = createSagaMiddleware();

export const runRootSaga = () => {
  sagaMiddleware.run(rootSaga);
};

const middleware = applyMiddleware(sagaMiddleware);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      name: 'Corporate Tube',
      serialize: {
        options: true,
      },
    })
  : compose;

export const store = createStore(rootReducer, composeEnhancers(middleware));
